import { AxiosInstance } from "axios";
import { CREATE_PARTY_PATH } from "../lib/path";
import BaseUseCase from "../lib/BaseUseCase";

class CreateFormUseCase extends BaseUseCase {
  constructor(client: AxiosInstance) {
    super(client);
  }

  async createParty(
    activityId: number,
    name: string,
    date: string,
    time: string,
    province: string,
    description: string,
    location: string
  ) {
    const config = this.getConfigHeaders();

    try {
      const response = await this.client.post(
        CREATE_PARTY_PATH,
        {
          locked_activity: activityId,
          name,
          date: `${date} ${time}`,
          province,
          description,
          location_description: location,
          capacity: 4,
          created_user: config.headers["user-id"],
          expiration_date: "1997-10-19 00:00:00",
        },
        config
      );

      return response.data;
    } catch (error) {
      return error.response.data;
    }
  }
}

export default CreateFormUseCase;
